import { useMutation } from '@tanstack/react-query';
import { Col, DatePicker, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import { CustomerApis } from 'apis/CustomerApis';
import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import {
  GET_STATUS_SALE_PLANNING,
  VARIABLES_GET_STATUS_SALE_PLANNING,
} from 'apis/GraphQL/Queries/codeQuery';
import { GET_ALL_PLANT } from 'apis/GraphQL/Queries/plantQuery';
import { ISearchRouteComboBox } from 'apis/GraphQL/Queries/saleLineQuery';
import { SaleLineApi } from 'apis/SaleLineApi';
import { SaleTeamApi } from 'apis/SaleTeamApi';
import { FormFilter, InputForm, SelectForm } from 'components';
import LazySelectForm, {
  ILazySelectData,
  ILazySelectParams,
  initLazySelectData,
} from 'components/Select/LazySelectForm';
import { useUser } from 'contexts/UserProvider';
import { IParamQraphQL } from 'interfaces/GraphQL/GraphQL';
import { IFilterTeamSaleCb } from 'interfaces/TeamSale/TeamSale';
import Content from 'layouts/Content';
import React, { useCallback, useEffect, useState } from 'react';
import { generateUUID } from 'utils/constants/functions';

interface IProps {
  isOpen: boolean;
  defaultFilter: any;
  onCancel: () => void;
  onFinish: (values: any) => void;
}

export enum HandOverStatusEnum {
  CHUA_BAN_GIAO = 'ChuaBanGiao',
  THU_KHO_BAN_GIAO = 'ThuKhoBanGiao',
  THU_QUY_BAN_GIAO = 'ThuQuyBanGiao',
  DA_BAN_GIAO = 'DaBanGiao',
}

const spanCol = 6;
const FilterHandover = (props: IProps) => {
  const { isOpen, defaultFilter, onCancel, onFinish } = props;
  const { user } = useUser();
  const [form] = useForm();
  const [statuses, setStatuses] = useState<any[]>([
    { label: 'Chưa bàn giao', value: HandOverStatusEnum.CHUA_BAN_GIAO },
    { label: 'Thủ kho bàn giao', value: HandOverStatusEnum.THU_KHO_BAN_GIAO },
    { label: 'Thủ quỹ bàn giao', value: HandOverStatusEnum.THU_QUY_BAN_GIAO },
    { label: 'Đã bàn giao', value: HandOverStatusEnum.DA_BAN_GIAO },
  ]);
  const [optionsBranch, setOptionsBranch] = useState<DefaultOptionType[]>([]);
  const [customerData, setCustomersInRoute] =
    useState<ILazySelectData>(initLazySelectData);
  const [teamSaleData, setTeamSaleData] =
    useState<ILazySelectData>(initLazySelectData);
  const [routeSaleData, setRouteSaleData] =
    useState<ILazySelectData>(initLazySelectData);

  const { mutate: getCustomersMutate, isPending: isGetCustomersMutatePending } =
    useMutation({
      mutationFn: (params: {
        pageSize: number;
        searchValue: string;
        plantId: string;
      }) => CustomerApis.getCustomersInCombobox(params),
      onSuccess: (res) => {
        if (res?.data?.getCustomer) {
          const data = res?.data?.getCustomer;

          setCustomersInRoute({
            options: data.items.map(
              (item: any) =>
                ({
                  label:
                    item?.id + (item?.storeName ? ` - ${item.storeName}` : ''),
                  value: item?.id,
                }) as DefaultOptionType,
            ),
            totalItems: data?.pageInfo?.totalItems,
          });
        }
      },
    });

  const mutationBranch = useMutation({
    mutationKey: ['getAllBranch'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      setOptionsBranch(
        res.data?.getPlant
          ? res.data?.getPlant.items.map((item: any) => ({
              label: item.id,
              value: item.id,
            }))
          : [],
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { isPending: getTeamSaleLoading, mutate: getTeamSales } = useMutation({
    mutationFn: (params: IFilterTeamSaleCb) =>
      SaleTeamApi.getAllTeamSaleCbSubSort(params),
    onSuccess: (res) => {
      if (res?.data?.getTeamSales) {
        const items = res.data?.getTeamSales?.items ?? [],
          totalItems = res.data?.getTeamSales?.pageInfo?.totalItems ?? 0;

        setTeamSaleData({
          options: items.map((item: any) => ({
            label: item.subId + ' - ' + item.name,
            value: item.id,
          })),
          totalItems: totalItems,
        });
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { isPending: getRouteLoading, mutate: getRouteCb } = useMutation({
    mutationFn: (params: ISearchRouteComboBox) =>
      SaleLineApi.getAllRouteComboBox(params),
    onSuccess: (res) => {
      if (res.data?.getRouteM) {
        const items = res.data?.getRouteM?.items || [];
        const totalItems = res.data?.getRouteM?.pageInfo?.totalItems || 0;

        setRouteSaleData({
          options: items.map((item: any) => ({
            label: `${item?.id} -  ${item?.name}`,
            value: item?.id,
            id: item?.id || generateUUID(),
          })),
          totalItems: totalItems,
        });
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { isPending: statusPending, mutate: getAllStatuses } = useMutation({
    mutationFn: () =>
      axiosGraphQL.post('/graphql', {
        query: GET_STATUS_SALE_PLANNING,
        variables: VARIABLES_GET_STATUS_SALE_PLANNING('107'),
      }),
    onSuccess: (data: any) => {
      const items = data.data?.getCode?.items || [];

      setStatuses(
        items.map((item: any) => ({
          label: item.name,
          value: item.id,
        })),
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    if (user?.isAdmin || user?.isHO) {
      mutationBranch.mutate({
        query: GET_ALL_PLANT,
        variables: {
          input: {
            id: {
              not: '5000',
            },
          },
        },
      });
    }
  }, []);

  useEffect(() => {
    form.setFieldsValue(defaultFilter);
  }, [defaultFilter, form]);

  const handleCustomerSelectScrollChange = useCallback(
    (params: ILazySelectParams) => {
      const { pageSize, value } = params;
      const formData = form.getFieldsValue();

      // console.log(formData);

      getCustomersMutate({
        pageSize,
        plantId: formData?.plantId,
        searchValue: value || '',
      });
    },
    [form],
  );

  const handleTeamSaleScrollChange = (params: ILazySelectParams) => {
    const plant = form.getFieldValue('plantId');
    const teamSaleParams: IFilterTeamSaleCb = {
      ...params,
      plantId: plant || defaultFilter.plantId,
    };

    getTeamSales(teamSaleParams);
  };

  const handleRouteSelectScrollChange = (params: ILazySelectParams) => {
    const plant = form.getFieldValue('plantId');
    getRouteCb({
      value: params.value,
      plantId: plant || defaultFilter.plantId,
      pageSize: params.pageSize,
    });
  };

  const handleCancel = () => {
    form.resetFields();
    form.setFieldsValue(defaultFilter);

    onCancel();
  };
  return (
    <Content isOpen={isOpen}>
      <FormFilter form={form} onFinish={onFinish} onCancel={handleCancel}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Khách hàng" name="customerId">
              <LazySelectForm
                data={customerData}
                loading={isGetCustomersMutatePending}
                placeholder="Tìm mã KH SAP/DMS"
                onSelectScrollChange={handleCustomerSelectScrollChange}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Mã đơn bán hàng" name="orderId">
              <InputForm placeholder="Tìm mã đơn bán hàng" />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Mã đơn dẻ" name="purchaseId">
              <InputForm placeholder="Tìm mã đơn dẻ" />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item
              label="Ngày tạo từ - đến"
              name="fromDateToDate"
              rules={[{ required: true, message: 'Vui lòng chọn ngày' }]}
            >
              <DatePicker.RangePicker
                placeholder={['Từ ngày', 'Đến ngày']}
                format={'DD/MM/YYYY'}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Chi nhánh" name="plantId">
              <SelectForm
                options={optionsBranch}
                disabled={!(user?.isAdmin || user?.isHO)}
                placeholder="Chọn chi nhánh"
                onChange={() => {
                  form.setFieldsValue({
                    teamSalesId: undefined,
                    routeId: undefined,
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Đội bán hàng" name="teamSalesId">
              <LazySelectForm
                customeSize={20}
                data={teamSaleData}
                placeholder="Chọn đội"
                loading={getTeamSaleLoading}
                onSelectScrollChange={handleTeamSaleScrollChange}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Tuyến" name="routeId">
              <LazySelectForm
                customeSize={20}
                data={routeSaleData}
                loading={getRouteLoading}
                placeholder="Chọn tuyến"
                onSelectScrollChange={handleRouteSelectScrollChange}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Trạng thái" name="status">
              <SelectForm
                loading={statusPending}
                placeholder="Chọn trạng thái"
                options={statuses}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterHandover;
